var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import '@polymer/paper-button/paper-button';
import '@polymer/paper-dialog/paper-dialog';
import { accountCircle, closeIcon } from './my-icons.js';
// This element is connected to the Redux store.
import { store } from '../store.js';
// These are the actions needed by this element.
import { firebaseSignOut } from '../actions/app.js';
// These are the shared styles needed by this element.
import { SharedStyles } from './shared-styles.js';
import { ButtonSharedStyles } from './button-shared-styles.js';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
let MyAccount = class MyAccount extends LitElement {
    static get styles() {
        return [SharedStyles, ButtonSharedStyles,
            css `
      .install_prompt {
        display: none;
      }
      .profileImage{
        height: 50px;
      }
    `];
    }
    render() {
        return html `
      <div>
  <button style="position: absolute; top: 10px; right: 10px" @click="${() => { this.shadowRoot.getElementById("account").open(); }}" title="Account">${accountCircle}</button>  
        <paper-dialog id="account" style="width:300px;height:400px; z-index: 99999;">
        <header style="background-color:var(--app-primary-color)">
          <button style="color: red;--paper-icon-button-ink-color: red;fill: red;position: absolute;right: 10px;top:5px" @click="${() => { this.shadowRoot.getElementById("account").close(); }}">${closeIcon}</button>
        </header>
        <div style="text-align:center;font-size: 1.25em;border-bottom: 1px solid grey;">${this._company && this._company.exists() ? this._company.data().name : ''}</div> 
        <img src="images/manifest/bws_banner.png" type="image/png" style="max-height: 100px;display: block;margin-left: auto;margin-right: auto;width: 40%;border: solid;border-radius: 10px;border-color:rgba(0, 0, 0, .25);">
        <div style="text-align:center;font-size: 1.1em">${this._person && this._person.exists() && this._person.get("thumbnail_200") ? html `<img class="profileImage" src="${this._person.get("thumbnail_200")}"/>` : ``}</div>
        <div style="text-align:center;font-size: 1.1em">${this._person && this._person.exists() ? this._person.data().name : ''}</div>
        <div class="Role" style="text-align:center;font-size: 1.1em;color: grey;margin: 5px; max-height:100px;overflow-y:scroll;">${this._person && this._person.exists() && this._person.data().roles ? html `<div>Roles</div><ul style="text-align: left;">${this._person.data().roles.map((r) => html `<li>${r}</li>`)}</ul>` : 'NO ROLES ASSIGNED'}</div> 
        <div>
            <paper-button @click="${() => { this._signOut(); }}" dialog-confirm autofocus style="background-color: #bbb;">Log Out</paper-button>
            <paper-button @click="${() => { this._sendPasswordReset(); }}" title="Send an email to your account to reset your password." dialog-confirm autofocus style="background-color: transparent;color: blue;text-decoration: underline;">Password Reset</paper-button>
        </div>  
        <div class="install_prompt" id="install_div">
          <paper-button @click="${() => { this.installClick(); }}" dialog-confirm autofocus style="background-color: #bbb;position: absolute;bottom: 10px; left: 10px">Install</paper-button>
          </div>
         </paper-dialog>
      </div>
    `;
    }
    _signOut() {
        store.dispatch(firebaseSignOut());
        setTimeout(function () { location.reload(); }, 250);
    }
    _sendPasswordReset() {
        let auth = getAuth(window.firebase);
        let currentUser = auth.currentUser;
        if (confirm("Do you want to reset your password?") && currentUser && currentUser.email)
            sendPasswordResetEmail(auth, currentUser.email);
    }
    installClick() {
        if (this.deferredPrompt) {
            this.deferredPrompt.prompt();
            // Wait for the user to respond to the prompt
            this.deferredPrompt.userChoice
                .then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                }
                else {
                    console.log('User dismissed the A2HS prompt');
                }
                this.deferredPrompt = null;
            });
            window.addEventListener('appinstalled', () => {
                console.log('a2hs installed');
            });
        }
    }
    constructor() {
        super();
        this._company = undefined;
        this._user = undefined;
        this._userProfileDoc = undefined;
        this._person = undefined;
        this.deferredPrompt = undefined;
        /*set elements here- use "this" for element variables       */
        window.addEventListener('beforeinstallprompt', (e) => {
            console.log("beforeinstall prompt fired");
            //Prevent Chrome 67 and earlier from automatically showing prompt
            e.preventDefault();
            //stash the event so it can be triggered later.
            this.deferredPrompt = e;
            //Update the UI notify the user they can add to home screen
            //showInstallPromotion();
            var d = this.shadowRoot.getElementById("install_div");
            if (d) {
                d.style.display = '';
            }
        });
    }
    firstUpdated() {
        var state = store.getState();
        this._company = state.app.companyDoc;
        this.requestUpdate("_company");
        this._user = state.app.user;
        this.requestUpdate("_user");
        this._userProfileDoc = state.app.userDoc;
        this.requestUpdate("_userProfileDoc");
        this._person = state.app.personDoc;
        this.requestUpdate("_person");
    }
};
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_company", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_user", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_userProfileDoc", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "_person", void 0);
__decorate([
    property({ type: Object })
], MyAccount.prototype, "deferredPrompt", void 0);
MyAccount = __decorate([
    customElement('my-account')
], MyAccount);
export { MyAccount };
